<template>
  <div class="warehouse-orders">
    <div class="e-form">
      <el-form
        :model="filter"
        inline
        ref="form"
        size="mini"
        label-position="top"
      >
        <div class="flex items-center justify-between">
          <el-form-item label="Warehouse" v-if="isAdmin">
            <el-select
              v-model="filter.warehouse_id_eq"
              filterable
              clearable
              style="width: 320px"
            >
              <el-option
                v-for="warehouse in options.warehouses"
                :key="warehouse.id"
                :label="warehouse.name"
                :value="warehouse.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="Container No." class="w-32">
            <el-input v-model="filter.container_no_cont" clearable />
          </el-form-item>
          <el-form-item label="Refer. No." class="w-32">
            <el-input v-model="filter.reference_no_cont" clearable />
          </el-form-item>
          <el-form-item label="ETA">
            <el-date-picker
              v-model="filter.terminal_eta_gteq"
              type="date"
              :value-format="'yyyy-MM-dd'"
            />
          </el-form-item>
          <el-form-item label=" ">
            <el-date-picker
              v-model="filter.terminal_eta_lteq"
              type="date"
              :value-format="'yyyy-MM-dd'"
            />
          </el-form-item>
          <el-form-item label="ERD">
            <el-date-picker
              v-model="filter.early_receiving_date_gteq"
              type="date"
              :value-format="'yyyy-MM-dd'"
            />
          </el-form-item>
          <el-form-item label=" ">
            <el-date-picker
              v-model="filter.early_receiving_date_lteq"
              type="date"
              :value-format="'yyyy-MM-dd'"
            />
          </el-form-item>
          <el-form-item label="Returned">
            <el-select
              v-model="filter.returned"
              filterable
              clearable
              style="width: 80px"
            >
              <el-option
                v-for="item in options.returnedStatuses"
                :key="item[1]"
                :label="item[0]"
                :value="item[1]"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label=" ">
            <el-button
              type="primary"
              @click="searchOrders"
              icon="el-icon-search"
              >Search</el-button
            >
          </el-form-item>
          <el-form-item label=" ">
            <el-button type="text" size="mini" @click="exportCsv">
              Export to CSV
            </el-button>
          </el-form-item>
          <div class="grow"></div>
          <el-form-item label=" ">
            <el-input
              clearable
              placeholder="Quick Table Filter"
              v-model.lazy="keyword"
              size="mini"
              style="width: 150px"
            >
              <i slot="prefix" class="el-input__icon el-icon-s-grid" />
            </el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-popover placement="right" width="300" trigger="click">
              <el-row :gutter="5">
                <el-col :span="24">
                  <label>
                    Columns: drag&sort
                    <el-button type="text" @click="resetColumns"
                      >reset</el-button
                    >
                  </label>
                  <draggable
                    v-model="columnOptions"
                    class="stripe"
                    draggable=".stripe-item"
                    ghost-class="ghost"
                    @change="moveColumn"
                  >
                    <div
                      v-for="column in columnOptions"
                      :key="column.name"
                      class="stripe-item"
                    >
                      <el-checkbox
                        v-model="column.visible"
                        :disabled="column.name == 'ID'"
                        @change="toggleColumn($event, column.name)"
                        >{{ column.name }}</el-checkbox
                      >
                    </div>
                  </draggable>
                </el-col>
              </el-row>
              <el-button slot="reference" icon="el-icon-setting"
                >Settings</el-button
              >
            </el-popover>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <ContainerWarehouseTable
      ref="table"
      :items="filteredItems"
      @initColumnOptions="initColumnOptions"
    />
    <center>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="pagination.pageSize"
        :current-page="pagination.currentPage"
        :total="pagination.total"
        @current-change="pageChange($event)"
      />
    </center>
  </div>
</template>
<script>
import api from "@/default/utils/api";
import ContainerWarehouseTable from "@/default/pages/containers/warehouse/table.vue";

export default {
  name: "ContainerWarehouse",
  mixins: [api],
  components: {
    ContainerWarehouseTable,
  },
  data() {
    return {
      count: 0,
      items: [],
      keyword: "",
      columnOptions: [],
      filter: {
        returned: "false",
      },
      pagination: {
        pageSize: 25,
        currentPage: 1,
        total: 0,
        loading: false,
      },
      options: {
        warehouses: [],
        returnedStatuses: [
          ["All", null],
          ["Yes", "true"],
          ["No", "false"],
        ],
      },
      fuseOptions: {
        shouldSort: true,
        threshold: 0.25,
        location: 0,
        distance: 100,
        maxPatternLength: 32,
        minMatchCharLength: 1,
        keys: [
          "id",
          "container_no",
          "reference_no",
          "ssline.name",
          "ctype",
          "terminal.name",
        ],
      },
      receivedData: {},
    };
  },
  async mounted() {
    await this.loadOrders();
  },
  computed: {
    vetable() {
      return this.$refs.table.$refs.table;
    },
    withItems() {
      return this.items.length > 0;
    },
    filteredItems() {
      let items = this.items;
      if (this.keyword.length >= 3)
        items = this.$search(this.keyword, items, this.fuseOptions).map(
          (o) => o.item,
        );
      return items;
    },
  },
  methods: {
    initColumnOptions() {
      this.columnOptions = this.getTableColumns("warehouse-order");
    },
    resetColumns() {
      this.$actions.updateTableColumns({ ["warehouse-order"]: [] });
      this.$refs.table.initCachedColumns();
    },
    toggleColumn(checked, name) {
      this.updateTableColumn("warehouse-order", name, { visbile: checked });
    },
    moveColumn() {
      this.columnOptions.forEach((column, index) => {
        column.order = index + 1;
      });
      this.$actions.updateTableColumns({
        ["warehouse-order"]: this.columnOptions,
      });
    },
    async searchOrders() {
      this.pagination.currentPage = 1;
      this.items = [];
      await this.loadOrders();
    },
    async pageChange(val) {
      this.pagination.currentPage = val;
      await this.loadOrders();
    },
    exportCsv() {
      this.getDownload("/api/v1/warehouses/orders.csv", {
        q: this.filter,
      });
    },
    async loadOrders() {
      try {
        this.vetable.loading();
        this.pagination.loading = true;
        const q = { ...this.filter };
        const response = await this.$http.get(
          "/api/v1/warehouses/orders.json",
          {
            params: { q, page: this.pagination.currentPage },
          },
        );
        this.pagination.currentPage = parseInt(response.data.current_page);
        this.pagination.pageSize = parseInt(response.data.page_size);
        this.pagination.total = parseInt(response.data.total);
        this.items = this._.uniqBy(response.data.containers || [], "id");
        this.options.warehouses = this._.uniqBy(
          response.data.warehouses || [],
          "id",
        );
      } catch (ex) {
        this.$message({ message: ex.response.data.errors, type: "error" });
      } finally {
        this.vetable.loaded();
        this.pagination.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.warehouse-orders {
  #eta-chart {
    border: 1px solid #ddd;
    margin-bottom: 10px;
    padding: 5px;
  }
}

.stripe {
  .stripe-item {
    cursor: pointer;

    label {
      width: 100%;
    }
  }
}
</style>
